import React from 'react';
import Breadcrumbs, {
  BreadcrumbItem,
  breadcrumbLabel as label,
} from '@/components/Breadcrumbs';
import { Submission } from '@/hooks/submissions/useSubmission';

function buildBreadcrumbs(submission: Submission): BreadcrumbItem[] {
  const currentItem: BreadcrumbItem = {
    label: label('Submission', submission.display_id || submission.title),
    path: null,
  };

  const { owner, study } = submission;

  if (!owner) {
    return [currentItem];
  }

  const studyItem: BreadcrumbItem | null = study
    ? {
        label: label('Study', study.display_id || study.protocol_number),
        path: study.can_view ? study.show_path : null,
      }
    : null;

  if (owner.type === 'Study') {
    const studyBreadcrumb: BreadcrumbItem = studyItem ?? {
      label: label('Study', owner.display_id),
      path: owner.can_view ? owner.show_path : null,
    };
    return [studyBreadcrumb, currentItem];
  }

  if (owner.type === 'StudySite') {
    const siteItem: BreadcrumbItem = {
      label: label('Site', owner.display_id),
      path: owner.can_view ? owner.show_path : null,
    };
    const items: BreadcrumbItem[] = [];
    // study is null when the parent site has no study (standalone site — study_id is nullable)
    if (studyItem) items.push(studyItem);
    items.push(siteItem, currentItem);
    return items;
  }

  return [currentItem];
}

interface SubmissionBreadcrumbsProps {
  submission: Submission;
}

const SubmissionBreadcrumbs: React.FC<SubmissionBreadcrumbsProps> = ({
  submission,
}) => <Breadcrumbs items={buildBreadcrumbs(submission)} />;

export default SubmissionBreadcrumbs;
